export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.f0c625f9ba0dda47f20c.worker.js");
}
